<ion-header>
  <div class="modal-header">
    <ion-toolbar>
      <div class="modal-title">
        <h3>Select a Channel</h3>
      </div>
      <ion-buttons slot="end">
        <ion-button
          fill="clear"
          shape="round"
          class="close-button"
          (click)="cancel()"
        >
          <ion-icon name="close"></ion-icon>
        </ion-button>
      </ion-buttons>
    </ion-toolbar>
  </div>

  <div *ngIf="isLoading" style="margin: 15px; width: 100%">
    <ion-skeleton-text
      animated
      style="width: 30%; height: 20px; margin-bottom: 10px"
    ></ion-skeleton-text>
  </div>

  <ion-card
    class="outline-card"
    *ngIf="teamConnectedToSlack && !userConnectedToSlack"
  >
    <ng-container *ngIf="!isLoading">
      <div
        class="admin-bar flex-space-between"
        style="border-radius: 8px; padding: 0"
      >
        <ion-button
          class="fake-button"
          fill="clear"
          color="dark"
          (click)="connectUserToSlack()"
          [disabled]="true"
        >
          <ion-icon
            name="information-circle-outline"
            class="padded-icon"
          ></ion-icon>
          Additional permissions are required to see private channels.
        </ion-button>

        <ion-button fill="clear" (click)="connectUserToSlack()">
          <ion-icon name="logo-slack" class="padded-icon"></ion-icon>
          Authorize Slack
        </ion-button>
      </div>
    </ng-container>
  </ion-card>

  <div
    class="flex-space-between flexed-align-center"
    *ngIf="
      teamConnectedToSlack && (channels?.length || availableWorkspaces?.length)
    "
  >
    <ion-searchbar
      mode="ios"
      class="search-bar"
      placeholder="Find a channel..."
      showCancelButton="never"
      [(ngModel)]="searchText"
      (ionChange)="handleFilters()"
    ></ion-searchbar>
    <div class="flexed" style="margin-left: 5px">
      <ion-button
        (click)="promptAddChannelById()"
        fill="clear"
        shape="round"
        title="Add channel by Slack ID"
        class="btn-small"
        style="margin-right: 5px"
        [hidden]="!teamConnectedToSlack"
      >
        <ion-icon name="add-circle-outline" slot="icon-only"></ion-icon>
      </ion-button>

      <ion-select
        *ngIf="connectedTeams?.length > 1 && !hideSecondaryTeams"
        [(ngModel)]="selectedTeam"
        (ionChange)="onTeamChanged()"
        style="font-size: 0.8rem; margin-right: 5px"
        interface="popover"
        placeholder="Select Team"
      >
        <ion-select-option *ngFor="let team of connectedTeams" [value]="team">{{
          team.name
        }}</ion-select-option>
      </ion-select>

      <ion-select
        *ngIf="
          selectedTeam?.slackEnterpriseId && availableWorkspaces?.length > 0
        "
        [(ngModel)]="selectedWorkspaceId"
        (ionChange)="onWorkspaceSelected()"
        placeholder="Select Workspace"
        interface="popover"
        style="font-size: 0.8rem; margin-right: 5px; min-width: 100px"
      >
        <ion-select-option
          *ngFor="let workspace of availableWorkspaces"
          [value]="workspace.id"
          >{{ workspace.name }}</ion-select-option
        >
      </ion-select>

      <ion-select
        [(ngModel)]="filterType"
        (ionChange)="handleFilters()"
        placeholder="Show All"
        interface="popover"
        style="font-size: 0.8rem; margin-right: 10px"
        [hidden]="hideChannelTypeFilter"
      >
        <ion-select-option value="all">All Channels</ion-select-option>
        <ion-select-option value="shared">Shared Only</ion-select-option>
        <ion-select-option value="internal">Internal Only</ion-select-option>
      </ion-select>
    </div>
  </div>
</ion-header>

<ion-content>
  <div
    *ngIf="!teamConnectedToSlack"
    class="flexed-align-center"
    style="margin-top: 25px; justify-content: center"
  >
    <div
      style="
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 15px;
      "
      *ngIf="!isLoading"
    >
      <div style="font-size: 16px; margin-bottom: 20px" class="admin-bar">
        <span>
          New features have been added that require you to re-authenticate to
          Slack before connecting additional channels.
        </span>
      </div>
      <a
        (click)="connectTeamToSlack()"
        [ngClass]="{ 'not-allowed': isConnecting }"
      >
        <img
          alt="Add to Slack"
          height="40"
          width="139"
          src="https://platform.slack-edge.com/img/add_to_slack.png"
          srcset="
            https://platform.slack-edge.com/img/add_to_slack.png    1x,
            https://platform.slack-edge.com/img/add_to_slack@2x.png 2x
          "
        />
      </a>
    </div>
  </div>
  <ion-list
    *ngIf="teamConnectedToSlack && channels?.length"
    class="no-padding transparent-bg"
  >
    <ion-item
      *ngFor="let channel of filteredChannels"
      (click)="handleChannelInteraction(channel)"
      button="true"
    >
      {{ channel.displayName }}
      <ion-icon
        name="checkmark"
        slot="end"
        *ngIf="isChannelSelected(channel)"
        style="margin: 0"
      ></ion-icon>
    </ion-item>
  </ion-list>
  <ion-list
    *ngIf="teamConnectedToSlack && isLoading && !channels?.length"
    class="no-padding transparent-bg"
  >
    <ion-item *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8]">
      <ion-skeleton-text
        animated
        style="width: 40%; height: 16px"
      ></ion-skeleton-text>
    </ion-item>
  </ion-list>
  <div
    *ngIf="
      !isLoading &&
      !isLoadingChannels &&
      (publicChannelsCursor || connectedChannelsCursor || userChannelsCursor) &&
      teamConnectedToSlack
    "
  >
    <ion-button size="full" (click)="loadChannels(true)" class="no-margin">
      Click to load more channels
    </ion-button>
  </div>
  <ion-list
    *ngIf="teamConnectedToSlack && isLoadingChannels && channels?.length"
    class="no-padding transparent-bg"
  >
    <ion-item *ngFor="let i of [1, 2, 3, 4]">
      <ion-skeleton-text
        animated
        style="width: 40%; height: 16px"
      ></ion-skeleton-text>
    </ion-item>
  </ion-list>
</ion-content>
